import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    display: flex;
    background: #F4FCF8;
    border: 1px solid #C7EFDA;
    white-space: nowrap;
    font-size: 14px;
    border-radius: 5px;
    color: ${displayState?.color ?? '#1DBD6B'};
    width: ${displayState?.width ?? ''};

    svg {
      fill: #1DBD6B;
      width: 8px;
      height: 8px;
      margin-right: 3px;
    }
  `}
`;

export default Wrapper(template);